import ImagesSection from './ImagesSection';

export default ImagesSection;